import { render, staticRenderFns } from "./FechasProyectadas.vue?vue&type=template&id=383fbb7f"
import script from "./FechasProyectadas.vue?vue&type=script&lang=js"
export * from "./FechasProyectadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports